import { BaseEntityDto } from '@fleet-beat/core';
import { VehicleParamsGroupEnum, VehicleParamsNameEnum } from './vehicle.dto';

export interface VehicleSocketParametersDto extends BaseEntityDto {
  group?: VehicleParamsGroupEnum;
  name?: VehicleParamsNameEnum;
  value?: string;
  metaData: {
    lat?: number;
    lon?: number;
    nearestPlace?: string;
  };
}
